// extracted by mini-css-extract-plugin
export default {"root":"hdRMUd","overlay":"UudY_t","title":"_3pKGF","settingBlock":"I1Xwsg","workingStatus":"sBQOk1","settingTitle":"J751ZC","notification":"OEq_ws"};